import { resetOnTimeout } from './Timeout'

var _pageUnloaded = false;
window.addEventListener('beforeunload', function () {
    _pageUnloaded = true;
});

export interface AjaxSuccess<R> {
    (data: R): any 
}

export interface AjaxError {
    (textStatus: string, errorThrown: string): any 
}

export interface ISupportSpinner {
    toggleSpinner(on: boolean, callback: {(): any}): void;
}

export interface AjaxSettings {
    method: string
    url: string
    responseType: string
    success: { (data: any): any }
    error: { (status: number, statusText: string, error: string): any }
    abort: { (): any }
    contentType?: string
    data?: any
}

export class Ajax {
    protected baseUrlLocal: string
    protected serviceUrlLocal: string
    private requestLocal: XMLHttpRequest

    constructor(baseUrlp: string, serviceUrlp: string) {
        this.baseUrlLocal = (baseUrlp || '').replace(/\/$/, '');
        this.serviceUrlLocal = (serviceUrlp || '').replace(/\/$/, '');
    }

    private ajax(settings: AjaxSettings) {
        this.cancel();

        let r = new XMLHttpRequest();
        r.open(settings.method, settings.url, true);
        if (settings.contentType)
            r.setRequestHeader("Content-Type", settings.contentType);
        r.setRequestHeader('x-osf-custom-header', 'osf');
        r.withCredentials = true;
        r.onreadystatechange = () => {
            let r = this.requestLocal;
            if (r && r.readyState == XMLHttpRequest.DONE) {
                this.requestLocal = null;

                if (r.status === 200 || r.status === 204) {
                    let data: any;
                    if (settings.responseType == 'text' && r.responseText) {
                        data = r.responseText.toString().replace(/^\"|\"$/g, '');
                    }
                    else if (r.responseText) {
                        data = JSON.parse(r.responseText);
                    }
                    else {
                        data = null;
                    }
                    settings.success && settings.success(data);
                }
                else if (r.status === 401) {
                    this.federate(settings);
                }
                else if (r.status === 509) {
                    setTimeout(() => {
                        this.ajax(settings);
                    }, 1000);
                }
                else if (r.statusText == 'abort' || _pageUnloaded) {
                    return;
                }
                else {
                    settings.error && settings.error(r.status, r.statusText, r.responseText);
                }
            }
        }
        r.onabort = () => {
            settings.abort && settings.abort();
        }
        r.send(settings.data);
        this.requestLocal = r;
    }

    protected federate(settings: AjaxSettings) {
        window.location.href = `${this.baseUrlLocal}/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
    }

    private handleException(callback: AjaxError, textStatus: string, errorThrown: string) {
        const messageMatch = errorThrown.match(/^[^:]+: (.*?)(\n|$)/s);
        const errorMessage = messageMatch ? messageMatch[1].split('\n')[0].trim() : "An error occurred";
        console.error(errorThrown);
        if (callback) {
            callback(textStatus, errorMessage);
        }
        else {
            alert("We're sorry, an error occurred. " + errorMessage);
            
        }
    }

    protected _call<R>(method: string, action: string, owner: ISupportSpinner, query: any, data: any, success: AjaxSuccess<R>, error?: AjaxError, responseType?: string) {
        let ajaxUrl = this.baseUrlLocal + this.serviceUrlLocal + "/" + action;

        let ajaxSettings: AjaxSettings = {
            url: ajaxUrl,
            method: method,
            responseType: responseType,
            success: (data: any) => {
                resetOnTimeout();
                if (owner) {
                    owner.toggleSpinner(false, () => {
                        success(<R>data);
                    });
                }
                else {
                    success(<R>data);
                }
            },
            error: (status: number, textStatus: string, errorThrown: string) => {
                if (owner) {
                    owner.toggleSpinner(false, () => {
                        this.handleException(error, textStatus, errorThrown);
                    });
                }
                else {
                    this.handleException(error, textStatus, errorThrown);
                }
            },
            abort: () => {
                if (owner) {
                    owner.toggleSpinner(false, () => { });
                }
            }
        };

        if (query != null) {
            let queryParams = '';
            for (let p in query) {
                let v = query[p];
                if (v === null)
                    continue;

                if (queryParams.length > 0) {
                    queryParams += '&';
                }

                queryParams += `${p}=${encodeURIComponent(v)}`;
            }
            if (queryParams.length > 0) {
                ajaxSettings.url += '?' + queryParams;
            }
        }

        if (method == "get" || method == "head") {
            if (ajaxSettings.url.indexOf("?") >= 0) {
                ajaxSettings.url += "&";
            }
            else {
                ajaxSettings.url += "?";
            }
            ajaxSettings.url += `_=${new Date().getTime()}`;
        }

        if (data) {
            ajaxSettings.contentType = 'application/json; charset=utf-8';
            ajaxSettings.data = JSON.stringify(data);
        }

        if (owner) {
            owner.toggleSpinner(true, () => {
                this.ajax(ajaxSettings);
            });
        }
        else {
            this.ajax(ajaxSettings);
        }
    }

    cancel() {
        if (this.requestLocal) {
            this.requestLocal.onreadystatechange = null;
            this.requestLocal.abort();
            this.requestLocal = null;
        }
    }
}
